import {
  SnippetElement,
  defineElement,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/common-article-card/common-article-card.ts
var CommonArticleCard = class extends SnippetElement {
  connectedCallback() {
    this.calculateReadingTime(this.readingTime.getAttribute("data-reading-time"));
  }
  calculateReadingTime(characterCount) {
    const charactersPerMinute = 1e3;
    const readingTime = Math.ceil(characterCount / charactersPerMinute);
    this.readingTime.innerHTML = readingTime.toString() + " Min.";
  }
  openVideoModal() {
    if (this.videoModal) {
      this.videoModal.open();
      if (this.videoPlayer) {
        this.videoPlayer.play();
      }
    }
  }
};
__decorateClass([
  query("[data-reading-time]")
], CommonArticleCard.prototype, "readingTime", 2);
__decorateClass([
  query("[data-video-modal]")
], CommonArticleCard.prototype, "videoModal", 2);
__decorateClass([
  query("[data-video-player]")
], CommonArticleCard.prototype, "videoPlayer", 2);
__decorateClass([
  onClick("[data-video-trigger]")
], CommonArticleCard.prototype, "openVideoModal", 1);
CommonArticleCard = __decorateClass([
  defineElement("common-article-card")
], CommonArticleCard);
export {
  CommonArticleCard
};
